import { cn } from 'noddi-ui-common';

/**
 * Swim lane: full width when stacked (mobile); max-width capped for horizontal scroll from md.
 */
export const swimLaneBookingCardWidth = cn('w-full min-w-0 shrink-0 md:w-auto md:max-w-48');

/** Fixed width for small cards: event cards (depot/break/reload) and compact booking cards (completed/cancelled/unable). */
const swimLaneSmallCardWidth = cn('w-full min-w-0 shrink-0 md:w-16 md:max-w-16 md:min-w-16');

/**
 * Inner padded region for booking cards (outer card is `p-0`). `pr-5` clears the CustomerNumber badge.
 */
export const swimLaneBookingCardBody = cn('flex w-full flex-col gap-0.5 p-2 pr-5');

/**
 * Wrapper around each swim-lane card so the row can stretch all items to the same height (md+ horizontal lane).
 */
export const swimLaneItemWrapper = cn('flex min-h-0 w-full shrink-0 flex-col md:w-auto md:self-stretch');

/** Outer card: grow to match tallest card in the horizontal swim lane (md+). */
export const swimLaneCardStretchInRow = cn('min-h-0 w-full md:flex-1');

/**
 * Compact / status booking cards: fill lane height on md+ without flex-growing in width.
 */
const swimLaneCardCompactInRow = cn('min-h-0 w-full md:h-full md:flex-none md:shrink-0');

/** Shared outer shell for small cards (depot/break/reload/completed/cancelled/unable). */
const routeCardStyling = cn('relative flex h-full min-h-15 flex-col items-center justify-center border p-2');

/** Base for event cards (depot / break / reload): shell + width + stretch + accent bg. */
export const routeEventCardBase = cn(routeCardStyling, swimLaneSmallCardWidth, swimLaneCardStretchInRow, 'bg-accent');

/** Base for compact booking cards (completed / cancelled / unable): shell + width + compact row + shadow. */
export const routeCompactBookingCardBase = cn(
  routeCardStyling,
  swimLaneSmallCardWidth,
  swimLaneCardCompactInRow,
  'relative shadow-xs'
);

/** Inner column: vertical stack, centered. */
export const routeCardInnerStyling = cn(
  'flex min-h-0 w-full min-w-0 flex-1 flex-col items-center justify-center gap-0.5 self-stretch text-center'
);

/** White rounded square behind card icons. */
export const routeCardEventIconWrap = cn(
  'flex size-6 shrink-0 items-center justify-center rounded-md border border-border/80 bg-card shadow-xs'
);

/** Truncated name text used in compact booking cards. */
export const compactCardNameText = cn('w-full min-w-0 truncate px-0.5 text-xs font-semibold');

/** Anchors status chips bottom-left. */
export const swimLaneCardBottomLeftStatus = cn(
  'pointer-events-none absolute bottom-0 left-0 z-10 flex max-w-full flex-col gap-1'
);

/** Same as above, row layout + pointer events for popover triggers on booking cards. */
export const swimLaneCardBottomLeftStatusRow = cn(
  'pointer-events-auto absolute bottom-0 left-0 z-10 flex max-w-full flex-row items-end gap-1'
);
